import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CenSpcIsOrderDetailsFieldCompletedState from "@tCentro/Store/Reducer/CenSpcIsOrderDetailsFieldCompletedState";
import { Draft } from "immer";

const initialState: CenSpcIsOrderDetailsFieldCompletedState = {
    isOrderDetailsFieldCompletedValue: false,
};

const reducer = {
    "Pages/OnePageCheckout/CenSpcOrderDetailsFieldCompleted": (
        draft: Draft<CenSpcIsOrderDetailsFieldCompletedState>,
        action: {
            isOrderDetailsFieldCompletedValue: boolean;
        },
    ) => {
        draft.isOrderDetailsFieldCompletedValue = action.isOrderDetailsFieldCompletedValue;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
